import React from "react";
import { Link } from "gatsby";
import de from "date-fns/locale/de";
import format from "date-fns/format/index";
var SearchResult = function SearchResult(_ref) {
    var result = _ref.result;
    // For Google PSE results, the slug will be the full URL, so we need to handle internal vs external links
    var isInternalLink = result.slug.includes("makroskop.eu");
    var linkPath = isInternalLink ? result.slug.replace(/^https?:\/\/[^\/]+/, "") : result.slug;
    var LinkComponent = isInternalLink ? Link : "a";
    var linkProps = isInternalLink ? {
        to: linkPath
    } : {
        href: result.slug,
        target: "_blank",
        rel: "noopener noreferrer"
    };
    return /*#__PURE__*/ React.createElement(LinkComponent, Object.assign({}, linkProps, {
        className: "block mb-8"
    }), /*#__PURE__*/ React.createElement("strong", {
        className: "font-medium underline text-xl block mb-1",
        dangerouslySetInnerHTML: {
            __html: result.title
        }
    }), /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: result.text
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "mt-1 text-sm text-gray-600"
    }, result.authors.length > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, result.authors.join(", "), result.pubDate && " | "), result.pubDate && format(new Date(result.pubDate), "dd. MMMM yyyy", {
        locale: de
    })));
};
export default SearchResult;
